import Nav from "react-bootstrap/Nav";

export function AdminPageSideNavbar() {
  return (
    <div className="admin-page__navsidebar">
      <Nav className="flex-column"></Nav>
    </div>
  );
}
